import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DragSource, DropTarget } from 'react-dnd';

const dragSource = DragSource;
const dropTarget = DropTarget;

const cardSource = {
  beginDrag(props) {
    return props;
  },
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  };
}

class TabBarItem extends Component {

  static propTypes = {
    title: PropTypes.string,
    className: PropTypes.string,
    onClose: PropTypes.func,
    onExpand: PropTypes.func,
    onSelectWrapper: PropTypes.func,
    connectDragSource: PropTypes.func,
    connectDropTarget: PropTypes.func,
    closeable: PropTypes.bool,
  }

  render() {
    const {
      liveKey,
      connectDragSource,
      connectDropTarget,
      closeable,
      title,
      onSelectWrapper,
      className,
      onClose,
      onExpand,
    } = this.props;

    const closeableContainer = (closeable) ?
      (
        <div className="closeable">
          <span className="ui-icon ui-icon-extlink" onClick={onExpand}>Open Window</span>
          <span className="ui-icon ui-icon-close" onClick={onClose}>Remove Tab</span>
        </div>
      ) : '';

    return connectDropTarget(
      connectDragSource(
        <a onClick={onSelectWrapper} className={className}>
          <span data-live-key={liveKey}>
            {title}
          </span>
          {closeableContainer}
        </a>
      )
    );
  }
}

const dropTargetConf = {
  drop(target, monitor) {
    const source = monitor.getItem();
    if (source.onMove) {
      source.onMove({ target, source });
    }
  },
};

const connectDropTargetConf = connect => ({
  connectDropTarget: connect.dropTarget(),
});

export default dropTarget('card', dropTargetConf, connectDropTargetConf)(
  dragSource('card', cardSource, collect)(TabBarItem)
);
